import React from "react";
import "./app.css";
import CalcIn from  "./components/calcIn" ;
import OO from "./components/oo.js"
import calculate from "./calculate.js";



 function App() {
    const [In1,setIn1] = React.useState(" ")
    const [In2,setIn2] = React.useState(" ")
    const [op,setOp] = React.useState(" ")
    const [result,setResult] = React.useState(" Im loading right now...")
    React.useEffect( () => {
        fetch(`/api/calc/?a=${In1}&op=${encodeURIComponent(op)}&b=${In2}`)
          .then( (res) => res.text())
          .then( (data) => setResult(data) )
          .catch((err) => setResult("i shall not be fetched"))
    }, )
    /*const result = calculate(In1,In2,op);*/
    return ( 
        <div className="RP">
            <title>calculator</title>
            <h1 className="greet"> Welcome to the test  calculator  </h1>
            <div className="ins">
              <CalcIn type="number" name="In 1" holder={setIn1} />
               <select onChange={(event) => {setOp(event.target.value)}}>
                <OO op="+"></OO>
                <OO op="-"></OO>
                <OO op="x"></OO>
                <OO op="/"></OO>
                <OO op="^"></OO>
                <OO op="%"></OO>
                <OO op="="></OO>
                <OO op="<"></OO>
                <OO op=">"></OO>
               </select>
              <CalcIn type='number' name="In 2" holder={setIn2} />
            </div>
            <h2> output = {result}</h2>
        </div>
    )
    }
    
export default App